import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Client } from '../../domain/client/Client';
import { ClientsTableColumn } from './tableColumns';

export enum ClientActionType {
  SEARCH_CLIENTS_SUCCESS = `SEARCH_CLIENTS_SUCCESS`,
  SET_CLIENTS_TABLE_COLUMNS = `SET_CLIENTS_TABLE_COLUMNS`,
  // DELETE_VEHICLE_SUCCESS = `DELETE_VEHICLE_SUCCESS`,
  // UPDATE_VEHICLE_SUCCESS = `UPDATE_VEHICLE_SUCCESS`,
}

export interface SearchClientsSuccessAction {
  type: ClientActionType.SEARCH_CLIENTS_SUCCESS;
  payload: {
    clients: PaginatedResult<Client>;
  };
}

export interface SetClientsTableColumnsAction {
  type: ClientActionType.SET_CLIENTS_TABLE_COLUMNS;
  payload: Array<ClientsTableColumn>;
}

// export interface DeleteVehicleSuccessAction {
//   type: VehicleActionType.DELETE_VEHICLE_SUCCESS;
//   payload: Vehicle;
// }
//
// export interface UpdateVehicleSuccessAction {
//   type: VehicleActionType.UPDATE_VEHICLE_SUCCESS;
//   payload: Vehicle;
// }

export type ClientActions = SearchClientsSuccessAction | SetClientsTableColumnsAction;
